import axios from "axios";
import config from "./index.js";
import { getToken } from "@/utils/tokenStorage";
import apiErrorHandler from "@/utils/apiErrorHandler";

const BASE_URL = config.BASE_URL;

const apiClientV1 = axios.create({
  baseURL: `${BASE_URL}/v1`,
});

apiClientV1.interceptors.request.use((cfg) => {
  const token = getToken();
  if (token) cfg.headers["Authorization"] = `Bearer ${token}`;
  return cfg;
});

apiClientV1.interceptors.response.use(
  (response) => response,
  apiErrorHandler
);

export default apiClientV1;
